<template>
  <div id="app" class="wrapper cyber-wrapper">
    <top-menu></top-menu>
    <left-menu></left-menu>

    <div class="content-wrapper">
      <router-view></router-view>
    </div>

    <footer-menu></footer-menu>
  </div>
</template>

<script>
import TopMenu from "./TopMenu.vue";
import LeftMenu from "./LeftMenu.vue";
import FooterMenu from "./FooterMenu.vue";

export default {
  name: "dashboard-layout",
  props: {
    msg: String,
  },
  mounted() {
    document.body.className = "sidebar-mini cyber-dashboard";
  },
  components: {
    TopMenu,
    LeftMenu,
    FooterMenu,
  },
};
</script>

<style>
.cyber-dashboard {
  background: #1a1a1a !important;
}

.cyber-wrapper {
  background: #1a1a1a !important;
}
</style>
